const isDevelopment = false

export class Environment {
    readonly baseUrl: string

    constructor({ baseUrl }: any) {
        this.baseUrl = baseUrl
    }

    static dev: Environment = new Environment({ baseUrl: " http://localhost:8080/" })
    static prod: Environment = new Environment({ baseUrl: "https://remaindme.online/api/" })

    static environment: Environment = isDevelopment ? this.dev : this.prod
}
